// src/components/LoadingScreen.js

import React, { useEffect } from 'react';
// ## NAYA CHANGE: Counter animation ke liye zaroori hooks import karein ##
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';

// Sound Wave Icon component waisa hi rahega
const AnimatedSoundWaveIcon = () => {
  const barAnimation = {
    animate: (i) => ({
      scaleY: [1, 1.5, 1, 0.8, 1],
      transition: {
        delay: i * 0.2,
        duration: 1.2,
        ease: 'easeInOut',
        repeat: Infinity,
      },
    }),
  };

  return (
    <div className="w-24 h-24 mb-6 flex justify-center items-center space-x-2">
      <motion.div className="w-4 h-10 bg-[#e11d48] rounded" variants={barAnimation} animate="animate" custom={0} />
      <motion.div className="w-4 h-16 bg-[#e11d48] rounded" variants={barAnimation} animate="animate" custom={1} />
      <motion.div className="w-4 h-8 bg-[#e11d48] rounded" variants={barAnimation} animate="animate" custom={2} />
    </div>
  );
};


const LoadingScreen = () => {
  // ## NAYA CHANGE: Counter ke liye animation logic ##
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));

  useEffect(() => {
    // 0 se 99 tak 3 second mein animate karega
    const controls = animate(count, 99, {
      duration: 3,
      ease: "easeInOut",
    });

    // Cleanup function: component unmount hone par animation rok dega
    return controls.stop;
  }, [count]); // Dependency array mein count

  return (
    // Poora layout thoda adjust kiya gaya hai
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white text-gray-800 z-50">
      
      <AnimatedSoundWaveIcon />

      {/* ## NAYA CHANGE: Loading text aur counter ## */}
      <div className="text-center">
        <h2 className="text-3xl font-bold text-gray-800">
          Application Loading
        </h2>
        <p className="mt-2 text-lg text-gray-500">
          Please wait... 
          <motion.span className="font-semibold text-gray-700">
            {rounded} 
          </motion.span>
          %
        </p>
      </div>

    </div>
  );
};

export default LoadingScreen;